module.exports = __webpack_public_path__ + "static/media/Logo-B-Free_0002_Livello-1.386d6c8f.png";